import Logger from '../Logger/Logger';
import { LogLabels } from '../Logger/LogLabels';
import { API_CONSTANTS } from './ApiConstants';
import { NextgenApiError } from './NextgenApiError';
import { Messages } from './types/message';
type ErrorCb = (res: Response) => void;
interface OverrideOptions {
  [key: string]: ErrorCb;
}

export class ErrorHandler {
  overrideOptions: OverrideOptions = {};
  loggerServiceInstance = Logger.getInstance();

  /**
   * check if any errros are overriden from FE
   * @param options override or extend errors
   *
   */
  constructor(options: OverrideOptions = {}) {
    this.overrideOptions = options;
  }

  /**
   * check if any errros are overriden from FE
   * @param apiRes response of the api
   */
  async handlerErrors(apiRes: Response) {
    this.loggerServiceInstance.debug(Messages.labels.L001, apiRes);
    if (this.overrideOptions[apiRes.status]) {
      this.overrideOptions[apiRes.status](apiRes);
    } else if (this.overrideOptions.default) {
      this.overrideOptions.default(apiRes);
    } else {
      await this.handleDefaultErrors(apiRes);
    }
  }

  /**
   * handling deafult errors
   * @param apiRes response of the api
   */
  async handleDefaultErrors(apiRes: Response) {
    this.loggerServiceInstance.debug(LogLabels.DefaultErrorHandler);
    const contentTypeHeader = apiRes.headers.get(API_CONSTANTS.contentType);
    let responseBody = {};
    if (contentTypeHeader?.includes('json')) {
      responseBody = await apiRes.json();
      this.loggerServiceInstance.debug(LogLabels.ResponseConvertedToJSON);
    }
    switch (apiRes.status) {
      case 400:
        throw new NextgenApiError(Messages.error.E006, responseBody);
      default:
        throw new NextgenApiError(Messages.error.E004, responseBody);
    }
  }
}
